import { cn } from '@/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'mm:animate-pulse mm:rounded-md mm:bg-primary/10',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
